import React from 'react';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import { Link } from 'react-router-dom';
import ProfileHeader from '../components/ProfileHeader';
import * as globals from '../globals.js';
import EDSFooter from '../components/EDSFooter';

const Osoba_powiazana_edytuj = () => {
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <div>
                    <a href="">
                        <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                    </a>
                </div>
                <ProfileHeader></ProfileHeader>
                <main className="responsive-padding margin-top-32">
                    <div className="row-align-items-center">
                        <svg
                            className="add-releted-icon"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M32.5 20H21.835L15.585 12.5H6.25C5.25574 12.501 4.30249 12.8964 3.59945 13.5994C2.8964 14.3025 2.50099 15.2557 2.5 16.25V23.75C2.50066 24.4128 2.76427 25.0483 3.23296 25.517C3.70166 25.9857 4.33716 26.2493 5 26.25V35C5.00066 35.6628 5.26427 36.2983 5.73296 36.767C6.20166 37.2357 6.83716 37.4993 7.5 37.5H12.5C13.1628 37.4993 13.7983 37.2357 14.267 36.767C14.7357 36.2983 14.9993 35.6628 15 35V26.25H12.5V35H7.5V23.75H5V16.25C5 15.9185 5.1317 15.6005 5.36612 15.3661C5.60054 15.1317 5.91848 15 6.25 15H14.415L20.665 22.5H32.5C32.8315 22.5 33.1495 22.6317 33.3839 22.8661C33.6183 23.1005 33.75 23.4185 33.75 23.75V27.5H31.25V35H27.5V27.5H25V35C25.0007 35.6628 25.2643 36.2983 25.733 36.767C26.2017 37.2357 26.8372 37.4993 27.5 37.5H31.25C31.9128 37.4993 32.5483 37.2357 33.017 36.767C33.4857 36.2983 33.7493 35.6628 33.75 35V30C34.4128 29.9993 35.0483 29.7357 35.517 29.267C35.9857 28.7983 36.2493 28.1628 36.25 27.5V23.75C36.249 22.7557 35.8536 21.8025 35.1506 21.0994C34.4475 20.3964 33.4943 20.001 32.5 20Z" />
                            <path d="M29.375 18.75C28.5097 18.75 27.6638 18.4934 26.9444 18.0127C26.2249 17.532 25.6642 16.8487 25.333 16.0492C25.0019 15.2498 24.9153 14.3701 25.0841 13.5215C25.2529 12.6728 25.6696 11.8933 26.2814 11.2814C26.8933 10.6696 27.6728 10.2529 28.5215 10.0841C29.3701 9.91526 30.2498 10.0019 31.0492 10.333C31.8487 10.6642 32.5319 11.2249 33.0127 11.9444C33.4934 12.6638 33.75 13.5097 33.75 14.375C33.7487 15.5349 33.2873 16.6469 32.4671 17.4671C31.6469 18.2873 30.5349 18.7487 29.375 18.75ZM29.375 12.5C29.0042 12.5 28.6417 12.61 28.3333 12.816C28.025 13.022 27.7846 13.3149 27.6427 13.6575C27.5008 14.0001 27.4637 14.3771 27.536 14.7408C27.6084 15.1045 27.787 15.4386 28.0492 15.7008C28.3114 15.9631 28.6455 16.1416 29.0092 16.214C29.3729 16.2863 29.7499 16.2492 30.0925 16.1073C30.4351 15.9654 30.728 15.725 30.934 15.4167C31.14 15.1084 31.25 14.7458 31.25 14.375C31.2493 13.8779 31.0516 13.4014 30.7001 13.0499C30.3486 12.6984 29.8721 12.5007 29.375 12.5Z" />
                            <path d="M10 11.25C9.0111 11.25 8.0444 10.9568 7.22215 10.4074C6.39991 9.85794 5.75904 9.07705 5.3806 8.16342C5.00217 7.24979 4.90315 6.24446 5.09608 5.27455C5.289 4.30465 5.76521 3.41373 6.46447 2.71447C7.16373 2.01521 8.05465 1.539 9.02455 1.34608C9.99446 1.15315 10.9998 1.25217 11.9134 1.6306C12.8271 2.00904 13.6079 2.64991 14.1574 3.47215C14.7068 4.2944 15 5.2611 15 6.25C14.9987 7.57568 14.4715 8.84668 13.5341 9.78407C12.5967 10.7215 11.3257 11.2487 10 11.25V11.25ZM10 3.75C9.50555 3.75 9.0222 3.89662 8.61108 4.17133C8.19995 4.44603 7.87952 4.83648 7.6903 5.29329C7.50108 5.75011 7.45158 6.25278 7.54804 6.73773C7.6445 7.22268 7.8826 7.66814 8.23224 8.01777C8.58187 8.3674 9.02732 8.6055 9.51228 8.70197C9.99723 8.79843 10.4999 8.74892 10.9567 8.5597C11.4135 8.37048 11.804 8.05005 12.0787 7.63893C12.3534 7.2278 12.5 6.74446 12.5 6.25C12.4993 5.58716 12.2357 4.95166 11.767 4.48297C11.2983 4.01427 10.6628 3.75066 10 3.75V3.75Z" />
                        </svg>
                        <h2 className="h2">Edytuj osobę powiązaną</h2>
                    </div>
                    <p className="margin-top-32">Osoba powiązana jest to ...</p>
                    <section className="margin-top-32">
                        <form id="edit-reletad-form" method="post" action="">
                            <fieldset>
                                <legend className="form__legend">
                                    Kim jesteś dla edytowanej osoby?
                                </legend>
                                <ul className="">
                                    <li className="radio-list-item">
                                        <input
                                            type="radio"
                                            name="edit-related-relation"
                                            id="edit-related-rodzic"
                                            className="form__radio"
                                            value="rodzic"
                                            required
                                        />
                                        <label
                                            htmlFor="edit-related-rodzic"
                                            className="form__label--radio"
                                        >
                                            Rodzicem
                                        </label>
                                    </li>
                                    <li className="radio-list-item">
                                        <input
                                            type="radio"
                                            name="edit-related-relation"
                                            id="edit-related-opiekun"
                                            className="form__radio"
                                            value="opiekun"
                                        />
                                        <label
                                            htmlFor="edit-related-opiekun"
                                            className="form__label--radio"
                                        >
                                            Opiekunem
                                        </label>
                                    </li>
                                    <li className="radio-list-item">
                                        <input
                                            type="radio"
                                            name="edit-related-relation"
                                            id="edit-related-rodzenstwo"
                                            className="form__radio"
                                            value="rodzenstwo"
                                        />
                                        <label
                                            htmlFor="edit-related-rodzenstwo"
                                            className="form__label--radio"
                                        >
                                            Rodzeństwem
                                        </label>
                                    </li>
                                </ul>
                            </fieldset>
                            <fieldset className="margin-top-32">
                                <legend className="form__legend">
                                    Podaj dane edytowanej osoby
                                </legend>
                                <div className="form__row margin-top-16">
                                    <label htmlFor="relation-fname" className="form__label">
                                        Imię<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="relation-fname"
                                        id="relation-fname"
                                        className="form__input"
                                        title="Wpisz swoję imię"
                                        value=""
                                        required
                                    />
                                </div>
                                <div className="form__row">
                                    <label htmlFor="relation-lname" className="form__label">
                                        Nazwisko<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="relation-lname"
                                        id="relation-lname"
                                        className="form__input"
                                        title="Wpisz swoję nazwisko"
                                        value=""
                                        required
                                    />
                                </div>
                                <div className="form__row">
                                    <fieldset>
                                        <legend className="form__legend">
                                            Płeć<sup> *</sup>
                                        </legend>
                                        <div className="radio-group">
                                            <input
                                                type="radio"
                                                name="relation-gender"
                                                id="relation-gender-female"
                                                className="form__radio"
                                                value="Kobieta"
                                                required
                                            />
                                            <label
                                                htmlFor="relation-gender-female"
                                                className="form__label--radio"
                                            >
                                                Kobieta
                                            </label>
                                            <input
                                                type="radio"
                                                name="relation-gender"
                                                id="relation-gender-male"
                                                className="form__radio"
                                                value="Mężczyzna"
                                            />
                                            <label
                                                htmlFor="relation-gender-male"
                                                className="form__label--radio"
                                            >
                                                Mężczyzna
                                            </label>
                                        </div>
                                    </fieldset>
                                </div>
                                <div className="form__row">
                                    <label htmlFor="edit-related-pesel" className="form__label">
                                        PESEL<sup> *</sup>
                                    </label>
                                    <input
                                        type="number"
                                        name="edit-related-pesel"
                                        id="edit-related-pesel"
                                        className="form__input"
                                        title="Podaj PESEL"
                                        value=""
                                        required
                                        pattern="[0-9]{11}"
                                    />
                                </div>
                                <div className="form__row">
                                    <label htmlFor="edit-related-bday" className="form__label">
                                        Data urodzenia (dd-mm-rrrr)<sup> *</sup>
                                    </label>
                                    <input
                                        type="date"
                                        name="edit-related-bday"
                                        id="edit-related-bday"
                                        className="form__input"
                                        title="Podaj datę urodzenia"
                                        value=""
                                        required
                                    />
                                </div>
                                <div className="form__row">
                                    <label htmlFor="edit-related-street" className="form__label">
                                        Ulica<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="edit-related-street"
                                        id="edit-related-street"
                                        className="form__input"
                                        title="Podaj nazwę ulicy"
                                        value=""
                                        required
                                    />
                                </div>
                                <div className="form__row form__row--home-numbers">
                                    <div>
                                        <label htmlFor="edit-related-house" className="form__label">
                                            Nr domu<sup> *</sup>
                                        </label>
                                        <input
                                            type="text"
                                            name="edit-related-house"
                                            id="edit-related-house"
                                            className="form__input"
                                            title="Podaj numer domu"
                                            value=""
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="edit-related-flat" className="form__label">
                                            Nr mieszkania
                                        </label>
                                        <input
                                            type="text"
                                            name="edit-related-flat"
                                            id="edit-related-flat"
                                            className="form__input"
                                            title="Podaj numer mieszkania"
                                            value=""
                                        />
                                    </div>
                                </div>
                                <div className="form__row">
                                    <label htmlFor="edit-related-city" className="form__label">
                                        Miejscowość<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="edit-related-city"
                                        id="edit-related-city"
                                        className="form__input"
                                        title="Podaj miasto"
                                        value=""
                                        required
                                    />
                                </div>
                                <div className="form__row">
                                    <label htmlFor="edit-related-zipcode" className="form__label">
                                        Kod pocztowy<sup> *</sup>
                                    </label>
                                    <input
                                        type="text"
                                        name="edit-related-zipcode"
                                        id="edit-related-zipcode"
                                        className="form__input"
                                        title="Podaj kod pocztowy"
                                        value=""
                                        required
                                        pattern="^\d{2}(?:[-\s]\d{3})?$"
                                    />
                                </div>
                                <div className="form__row">
                                    <label htmlFor="edit-related-mail" className="form__label">
                                        E-mail<sup> *</sup>
                                    </label>
                                    <input
                                        type="email"
                                        name="edit-related-mail"
                                        id="edit-related-mail"
                                        className="form__input"
                                        title="Podaj e-mail"
                                        value=""
                                        required
                                        pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                    />
                                </div>
                                <div className="form__row">
                                    <label htmlFor="edit-related-phone" className="form__label">
                                        Nr telefonu<sup> *</sup>
                                    </label>
                                    <input
                                        type="tel"
                                        name="edit-related-phone"
                                        id="edit-related-phone"
                                        className="form__input"
                                        title="Podaj nr telefonu"
                                        value=""
                                        required
                                    />
                                </div>
                                <div className="form__row">
                                    <p className="checkbox-group">
                                        <input
                                            type="checkbox"
                                            id="edit-related-agreement"
                                            name="edit-related-agreement"
                                            className="form__checkbox"
                                            required
                                        />
                                        <label
                                            htmlFor="edit-related-agreement"
                                            className="form__label--checkbox consent_checkbox"
                                        >
                                            <div>Akceptuję Klauzulę informacyjną RODO:</div>
                                            <ul>
                                                {globals.USER_CONSENTS.map((consent) => (
                                                    <li>{consent}</li>
                                                ))}
                                            </ul>
                                        </label>
                                    </p>

                                    <p className="checkbox-group">
                                        <input
                                            type="checkbox"
                                            id="edit-related-regulations"
                                            name="edit-related-regulations"
                                            className="form__checkbox"
                                            required
                                        />
                                        <label
                                            htmlFor="edit-related-regulations"
                                            className="form__label--checkbox"
                                        >
                                            Akceptuję{' '}
                                            <a
                                                href={globals.TERMS_URL}
                                                className="text-link"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                Regulamin
                                            </a>
                                        </label>
                                    </p>
                                </div>
                            </fieldset>
                            <input
                                type="submit"
                                className="btn-primary margin-top-32"
                                value="Zatwierdź"
                            />
                        </form>
                        <div>
                            <a href="" className="btn-secondary margin-top-32 margin-bottom-32">
                                Anuluj
                            </a>
                        </div>
                    </section>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Osoba_powiazana_edytuj;
